module.exports = __webpack_public_path__ + "img/h15.a971fcff.jpg";